import { Col, Placeholder } from 'react-bootstrap';

const PlaceholderFilterSection = () => {
  return (
    <>
      <Col xs={2}>
        <Placeholder animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      </Col>
      <Col xs={2}>
        <Placeholder animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      </Col>
    </>
  );
};

export default PlaceholderFilterSection;
